'use strict';

const getProjectLocation = fileDir => {
  const fileDirArr = fileDir.split('/');
  const srcIndex = fileDirArr.indexOf('src');
  return fileDirArr.slice(srcIndex + 1) // Remove folders up to the "src" dir.
  .slice(0, -3) // Remove "stories" and its parent folder.
  .join('/');
};

module.exports = getProjectLocation;
